var _defs, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    height: 30,
    width: 30,
    viewBox: "111.793 71.071 31.118 31.502",
    style: {
      enableBackground: "new 0 0 330.001 330.001"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n            fill: #f1f1f1;\n            }\n\n            .b {\n            fill: #888;\n            fill-rule: evenodd;\n            }\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 127.561,
    cy: 86.84,
    r: 15
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    fill: "#888",
    d: "M 128.718 79.371 C 128.718 79.371 128.718 79.371 128.718 79.371 C 127.778 79.371 126.895 79.737 126.231 80.401 C 125.566 81.066 125.2 81.949 125.2 82.889 L 125.2 89.221 C 125.2 90.385 126.147 91.332 127.311 91.332 C 128.475 91.332 129.422 90.385 129.422 89.221 L 129.422 85.567 C 129.422 85.179 129.107 84.863 128.718 84.863 C 128.33 84.863 128.015 85.179 128.015 85.567 L 128.015 89.221 C 128.015 89.609 127.699 89.925 127.311 89.925 C 126.923 89.925 126.607 89.609 126.607 89.221 L 126.607 82.889 C 126.607 82.325 126.827 81.795 127.226 81.396 C 127.624 80.998 128.154 80.778 128.718 80.778 C 129.882 80.778 130.829 81.725 130.829 82.889 L 130.829 89.925 C 130.829 91.864 129.251 93.442 127.311 93.442 C 126.371 93.442 125.488 93.077 124.824 92.412 C 124.159 91.748 123.793 90.864 123.793 89.925 L 123.793 82.889 C 123.793 82.5 123.478 82.185 123.09 82.185 C 122.701 82.185 122.386 82.5 122.386 82.889 L 122.386 89.925 C 122.386 91.24 122.898 92.477 123.829 93.407 C 124.759 94.337 125.996 94.85 127.311 94.85 C 130.027 94.85 132.236 92.64 132.236 89.925 L 132.236 82.889 C 132.236 80.949 130.658 79.371 128.718 79.371 Z",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentCircle);
export default __webpack_public_path__ + "static/media/attachment-circle.65095e6572c7ff3646e99714590af758.svg";
export { ForwardRef as ReactComponent };